module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard grid-container"
  }, [_c('div', {
    staticClass: "dashboard-header"
  }, [_c('sl-switcher'), _vm._v(" "), _c('div', {
    staticClass: "sl-btn-list"
  }, [(_vm.$store.state.user.userinfo.roleId === '2') ? _c('router-link', {
    staticClass: "sl-el-btn sl-btn-green",
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Choose-Coupon'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', '+ Create New Coupon', 'Dashboard')
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('Views.Coupons.CNC')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dashboard-stats"
  }, [_c('sl-show-box', {
    attrs: {
      "data": _vm.box
    }
  })], 1), _vm._v(" "), _c('el-card', {
    staticClass: "dashboard-chart",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    slot: "header"
  }, [_c('span', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.revenue')) + " (" + _vm._s(_vm.$store.state.theme.companyInfo.currency) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "sl-body"
  }, [_c('chart', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.rLoading),
      expression: "rLoading"
    }],
    ref: "revenue",
    attrs: {
      "options": _vm.revenueConfig.default,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)]), _vm._v(" "), _c('el-card', {
    staticClass: "dashboard-chart",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    slot: "header"
  }, [_c('span', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.numberOfOrder')))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-body"
  }, [_c('chart', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.nooLoading),
      expression: "nooLoading"
    }],
    ref: "order",
    attrs: {
      "options": _vm.orderConfig.default,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newUser),
      expression: "newUser"
    }],
    staticClass: "sl-mask"
  }, [_c('div', {
    staticClass: "sl-block-welcome"
  }, [_c('p', {
    staticClass: "sl-title"
  }, [_vm._v(_vm._s(_vm.$t('Views.Dashboard.welTitle')))]), _vm._v(" "), _c('p', {
    staticClass: "sl-cnt"
  }, [_vm._v(_vm._s(_vm.$t('Views.Dashboard.welCnt')))]), _vm._v(" "), _c('div', {
    staticClass: "sl-btn",
    on: {
      "click": _vm.goDashboard
    }
  }, [_vm._v(_vm._s(_vm.$store.state.theme.companyInfo.welcome))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-cd546db8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard.vue
// module id = 1128
// module chunks = 1